import type { Dispatch } from "react";
import type { EditorAction } from "../../editor/reducers";
import { useState } from "react";
import { assertTypeName } from "../../client/guards";
import { RegionUpdateForm } from "../RegionUpdateForm";
import { PaginationArtifactFormField } from "../../attributes/pagination-artifact/PaginationArtifactFormField";
import {
  PaginationArtifactType,
  useArtifactRegionEditorSuspenseQuery,
  useUpdateArtifactRegionMutation,
} from "../../client/generated";

type Props = {
  paginationArtifactAttributeId: string;
  dispatch: Dispatch<EditorAction>;
};

export function ArtifactRegionEditor({
  paginationArtifactAttributeId,
  dispatch,
}: Props) {
  const { data } = useArtifactRegionEditorSuspenseQuery({
    variables: {
      paginationArtifactAttributeId,
    },
  });

  const { paginationArtifactAttr } = data;
  assertTypeName(
    paginationArtifactAttr?.__typename === "PaginationArtifactAttribute",
  );

  const [updateRegion] = useUpdateArtifactRegionMutation();
  const [paginationArtifactType, setPaginationArtifactType] = useState(
    paginationArtifactAttr.type,
  );

  const onSubmit = async (event: React.FormEvent) => {
    event.preventDefault();

    const result = await updateRegion({
      variables: {
        paginationArtifactAttributeId,
        paginationArtifactType,
      },
    });

    return (
      !result.errors &&
      !result.data?.updatePaginationArtifactAttribute.userErrors?.length
    );
  };

  return (
    <RegionUpdateForm onSubmit={onSubmit} dispatch={dispatch}>
      <PaginationArtifactFormField
        value={paginationArtifactType}
        onValueChange={(newArtifactType: PaginationArtifactType) =>
          setPaginationArtifactType(newArtifactType)
        }
      />
    </RegionUpdateForm>
  );
}
